﻿var moment = require('moment');

module.exports = {
    controller: navbarController,
    templateUrl: 'widgets/components/navbar.html'
};

navbarController.$inject = [
    '$analytics', 
    '$location', 
    'common', 
    'documentationService', 
    'favoritesService', 
    'notificationsService',
    'preferenceService', 
    'applicationStateService',
    'usTariffDataService'
];

function navbarController(
    $analytics, 
    $location, 
    common, 
    documentationService, 
    favoriteService, 
    notifications,
    preferences, 
    state,
    usTariffDataService
) {
    var vm = {
        $onInit: attached,
        $onDestroy: detached,
        config: common.config,
        identity: common.identity,
        favoriteService: favoriteService,
        language: common.language,
        openFavorite: openFavorite,
        removeFavorite: removeFavorite,
        setLanguage: setLanguage,
        showReferenceDatePicker: showReferenceDatePicker,
        showReferenceDateNotification: showReferenceDateNotification,
        showSidebar: false,
        supportedLanguages: common.language.supportedLanguages,
        state: state,
        toggle: toggle,
        htsReleaseName: null
    };

    function attached() {
        updateHtsReleaseName();
        notifications.subscribe('filter_date_changed', dateChanged);
        notifications.subscribe('filter_movement_changed', movementChanged);
    }

    function detached() {
        notifications.unsubscribe('filter_date_changed', dateChanged);
        notifications.unsubscribe('filter_movement_changed', movementChanged);
    }

    function dateChanged() {
        updateHtsReleaseName();
    }

    function movementChanged() {
        updateHtsReleaseName();
    }

    function updateHtsReleaseName() {
        if (state.filter.referenceCountry === 'US' && state.filter.movement === 'import') {
            usTariffDataService.getHtsRelease().then(function (htsReleaseName) {
                vm.htsReleaseName = htsReleaseName;
            });
        }
        else {
            vm.htsReleaseName = null;
        }
    }

    function toggle() {
        vm.showSidebar = !vm.showSidebar;
        if (vm.showSidebar) {
            $analytics.eventTrack('open-main-nav', { category: 'navigation' })
        }
        documentationService.initialize('menu');
    }

    function showReferenceDateNotification() {
        return showReferenceDatePicker() && state.filter.date !== moment().format('YYYY-MM-DD');
    }

    function showReferenceDatePicker() {
        if ($location.path().indexOf('/case-law') === 0) {
            return false;
        }
        if ($location.path().indexOf('/compliance-check') === 0) {
            return false;
        }
        if ($location.path().indexOf('/account') === 0) {
            return false;
        }
        if ($location.path().indexOf('/correlation-table') === 0) {
            return false;
        }
        return true;
    }

    function openFavorite(goodscode, movement, $event) {
        if (!movement) {
            movement = 'import';
        }
        state.filter.movement = movement;
        preferences.replace({
            name: 'movement',
            category: 'user_preferences',
            value: movement,
            valueType: 'stringValue'
        });
        vm.showSidebar = false;
        $location.url('/search/' + goodscode);
    }

    function removeFavorite(goodscode, movement, $event) {
        favoriteService.remove(goodscode, movement);
        $event.stopPropagation();
    }

    function setLanguage(lang) {
        preferences.setLanguage(lang);
    }

    return vm;
}
